import { makeStyles, AppBar, Tabs, Tab } from "@material-ui/core";
import React, { memo } from "react";
import TabPanel from "components/Admin/TabPanel";
function a11yProps(index: number) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

interface Props {
  title: string;
  children: any;
}

const Widget: React.FC<Props> = ({ children, title }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={0}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label={title} {...a11yProps(0)} />
        </Tabs>
      </AppBar>

      <TabPanel value={0} index={0}>
        {children}
      </TabPanel>
    </div>
  );
};

export default memo(Widget);
